import { ChangeDetectionStrategy, Component, OnInit, TemplateRef, Type } from '@angular/core';
import { VexPopoverContent, VexPopoverRef } from './vex-popover-ref';
import { popoverAnimation } from '../../animations/popover.animation';
import { NgComponentOutlet, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'vex-popover',
    templateUrl: './vex-popover.component.html',
    styleUrls: ['./vex-popover.component.scss'],
    animations: [popoverAnimation],
    imports: [NgTemplateOutlet, NgComponentOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VexPopoverComponent implements OnInit {
  renderMethod: 'template' | 'component' | 'text' = 'component';
  content!: VexPopoverContent;
  context: { close: () => void } | null = null;

  // Typed getters for template bindings
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get templateContent(): TemplateRef<any> | null {
    return this.content instanceof TemplateRef ? this.content : null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get componentContent(): Type<any> | null {
    return typeof this.content === 'function' ? this.content : null;
  }

  get textContent(): string {
    return typeof this.content === 'string' ? this.content : '';
  }

  constructor(private popoverRef: VexPopoverRef) {}

  ngOnInit() {
    this.content = this.popoverRef.content;

    if (typeof this.content === 'string') {
      this.renderMethod = 'text';
    }

    if (this.content instanceof TemplateRef) {
      this.renderMethod = 'template';
      this.context = {
        close: this.popoverRef.close.bind(this.popoverRef)
      };
    }
  }
}
